import { Fragment, useState, useEffect } from 'react'
import { FormattedMessage } from 'react-intl'
import setQuery from 'set-query-string'
import reject from 'lodash/reject'
import filter from 'lodash/filter'

import DealsFilters from './DealsFilters'
import DealsTitle from './DealsTitle'
import { generateMonthPicker } from 'utils'
import { OPERATOR_TYPES } from './helpers'
import { useDispatch } from 'react-redux'
import { createUrl } from '../../localized-urls'
import { setFilters, setPageType } from '../../actions/special-deals-actions'

const monthes = generateMonthPicker()

export default function DealsSearch() {
  const dispatch = useDispatch()
  const [type, setType] = useState(() => {
    return filter(OPERATOR_TYPES, { id: window.pageType })
  })
  const [selectedMonthes, setSelectedMonthes] = useState([])
  const [selectedCountries, setSelectedCountries] = useState([])
  const removeSelectedMonth = (from) => {
    setSelectedMonthes((monthes) => reject(monthes, { from }))
  }
  const removeSelectedCountry = (id) => {
    setSelectedCountries((countries) => reject(countries, { id }))
  }
  const setDealsType = (type) => {
    setType(type)
    dispatch(setPageType(type.id))
    window.history.pushState(
      {},
      null,
      `${window.location.origin}${createUrl(
        type.id,
        null,
        window.location.search
      )}`
    )
  }

  useEffect(() => {
    const country = selectedCountries.map((country) => country.id)
    const date = selectedMonthes.map((date) => date.from)
    setQuery({ country, date })
    dispatch(
      setFilters({
        date,
        country,
      })
    )
  }, [selectedMonthes, selectedCountries])

  return (
    <Fragment>
      <DealsTitle monthes={monthes} />
      <p className='subtitle'>
        <FormattedMessage
          id='unbeatable_deals'
          defaultMessage='Looking for unbeatable deals on liveaboard trips or dive resorts? Check-out the limited-time offers below and grab one before it`s gone!'
        />
      </p>
      <DealsFilters
        type={type}
        monthes={monthes}
        setDealsType={setDealsType}
        selectedMonthes={selectedMonthes}
        setSelectedMonthes={setSelectedMonthes}
        setSelectedCountries={setSelectedCountries}
        selectedCountries={selectedCountries}
        removeSelectedMonth={removeSelectedMonth}
        removeSelectedCountry={removeSelectedCountry}
      />
    </Fragment>
  )
}
